import React from "react";
import Button from "../baseComponents/gui/button/Button";
import buttonStyles from "../baseComponents/gui/button/Button.module.scss";
import {safeHTML} from "../../utils/safeHTML";
import styles from "./Quiz.module.scss"
import classNames from "classnames";

const QuizResult = React.forwardRef(
  function QuizResult(props, ref) {
    const {content, repeat, score} = props;

    const item = content.find(({max_score, min_score}) => score >= min_score && score < max_score);

    return (
      <div className={styles.quiz__result} ref={ref}>
        <div className={styles.quiz__preview}>
          <img src={item?.image} alt="Превью" loading="lazy" fetchpriority={"auto"} width={1312} height={600}/>
        </div>
        <div className={styles.quiz__result - content}>
          <h2 className={styles.quiz__resultTitle}>{safeHTML(item.title)}</h2>
          <div className={styles.quiz__resultText}>{safeHTML(item.description)}</div>
          <div className={styles.quiz__resultButtons}>
            <Button
              className={classNames(
                buttonStyles.button_border,
                buttonStyles.button_white,
                buttonStyles.button_big,
                styles.quiz__button,
                styles.quiz__button_repeat)}
              onClick={repeat}
            >
              <span className={buttonStyles.button__text}>{`Пройти ещё раз`}</span>
            </Button>
            <Button
              tag={"a"}
              className={classNames(
                buttonStyles.button_big,
                buttonStyles.button_black,
                styles.quiz__button,
                styles.quiz__button_back
              )}
              href={"/"}
            >
              <span className={buttonStyles.button__text}>{`На главную`}</span>
            </Button>
          </div>
        </div>

      </div>
    );
  });
export default QuizResult;
QuizResult.propTypes = {};

